var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useContext } from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { loggedContext } from '../utils/loggedContext';
import { UserRole, } from '../server-types';
var userInfoQuery = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tquery UserDataQuery {\n\t\tcurrentUser {\n\t\t\tid\n\t\t\tlocalId\n\t\t\tfirstName\n\t\t\tlastName\n\t\t\tlangCode\n\t\t\tname\n\t\t\temail\n\t\t\tworkEmail\n\t\t\trole\n\t\t\tstatus\n\t\t\tinternalCapabilities\n\t\t\tsocialType\n\t\t\tmanagedByUsers {\n\t\t\t\tid\n\t\t\t\tcapabilities\n\t\t\t\tCompany {\n\t\t\t\t\tid\n\t\t\t\t\tname\n\t\t\t\t\tbillingBranch {\n\t\t\t\t\t\tid\n\t\t\t\t\t\tCountry {\n\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\tcode\n\t\t\t\t\t\t\tname\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tRetailer {\n\t\t\t\t\tid\n\t\t\t\t\tname\n\t\t\t\t\tCountry {\n\t\t\t\t\t\tid\n\t\t\t\t\t\tcode\n\t\t\t\t\t\tname\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tCompanyGroup {\n\t\t\t\t\tid\n\t\t\t\t\tname\n\t\t\t\t}\n\t\t\t\tService {\n\t\t\t\t\tid\n\t\t\t\t\tname\n\t\t\t\t}\n\t\t\t\tGeoIndication {\n\t\t\t\t\tid\n\t\t\t\t\tname\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n"], ["\n\tquery UserDataQuery {\n\t\tcurrentUser {\n\t\t\tid\n\t\t\tlocalId\n\t\t\tfirstName\n\t\t\tlastName\n\t\t\tlangCode\n\t\t\tname\n\t\t\temail\n\t\t\tworkEmail\n\t\t\trole\n\t\t\tstatus\n\t\t\tinternalCapabilities\n\t\t\tsocialType\n\t\t\tmanagedByUsers {\n\t\t\t\tid\n\t\t\t\tcapabilities\n\t\t\t\tCompany {\n\t\t\t\t\tid\n\t\t\t\t\tname\n\t\t\t\t\tbillingBranch {\n\t\t\t\t\t\tid\n\t\t\t\t\t\tCountry {\n\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\tcode\n\t\t\t\t\t\t\tname\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tRetailer {\n\t\t\t\t\tid\n\t\t\t\t\tname\n\t\t\t\t\tCountry {\n\t\t\t\t\t\tid\n\t\t\t\t\t\tcode\n\t\t\t\t\t\tname\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tCompanyGroup {\n\t\t\t\t\tid\n\t\t\t\t\tname\n\t\t\t\t}\n\t\t\t\tService {\n\t\t\t\t\tid\n\t\t\t\t\tname\n\t\t\t\t}\n\t\t\t\tGeoIndication {\n\t\t\t\t\tid\n\t\t\t\t\tname\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n"])));
function isItalian(company) {
    return (company &&
        company.billingBranch &&
        company.billingBranch.Country &&
        company.billingBranch.Country.code === 'IT');
}
export var UserData = function (_a) {
    var children = _a.children;
    var userKey = useContext(loggedContext);
    var notLogged = !userKey;
    return (React.createElement(Query, { query: userInfoQuery, errorPolicy: 'all', skip: notLogged }, function (_a) {
        /**
         * NOTA BENE: la politica di gestione degli errori e' assente in quanto
         * un errore viene comunque considerato "utente non loggato"
         */
        var _b;
        var loading = _a.loading, data = _a.data;
        var currentUser = data && data.currentUser;
        var internalCapabilities = !data || !currentUser ? [] : currentUser.internalCapabilities;
        var managed = (data && ((_b = currentUser === null || currentUser === void 0 ? void 0 : currentUser.managedByUsers) === null || _b === void 0 ? void 0 : _b.filter(function (m) {
            if (m && typeof m == 'object' && 'Company' in m) {
                return !!m.Company;
            }
            return false;
        })[0])) ||
            undefined;
        var managedCapabilities = managed ? managed.capabilities : [];
        var capabilities = __spreadArrays(internalCapabilities, managedCapabilities);
        var props = {
            loading: loading,
            isLogged: !loading && !!data && !!currentUser,
            userData: currentUser,
            userIsBuyer: data && currentUser && currentUser.role === UserRole.Buyer,
            userHasCapability: function (capability) { return capabilities.includes(capability); },
            capabilities: capabilities,
            isInternal: currentUser && currentUser.role === UserRole.Internal,
            managedCompany: managed,
            managedCompanyIsItalian: (managed && isItalian(managed.Company)) || undefined,
        };
        return children(props);
    }));
};
var templateObject_1;
//# sourceMappingURL=UserData.js.map